removeUtm();


// if($(".colorPik .c-variant-selector--non-stick .c-variant-selector__toggle-wrapper").length > 0){
// if($(".o-toggle__switch.is-active").html().includes('Mini')){
//   $(`.is-template-product .colorPik .o-swatch[data*='Standard']`).addClass('hiddenCol');
// }else{
//   $(`.is-template-product .colorPik .o-swatch[data*='Mini']`).addClass('hiddenCol');
// }
// $(".o-toggle").click(function(){
//   	var size = $(this).find($(".o-toggle__switch.is-active")).html();
//   	$(".is-template-product .colorPik .o-swatch").addClass('hiddenCol');
//     $(`.is-template-product .colorPik .o-swatch[data*='${size}']`).removeClass('hiddenCol');
//     $(`.is-template-product .colorPik .o-swatch[data*='${size}']`).eq(0).find("label").click();
// });
// }

var numfirstAvailP = $('.firstAvailP').html();
if(numfirstAvailP != ""){
	var availCol = $(".varSel .o-swatch:not(.hiddenCol)").find($("label"));
  	$(availCol[0]).click();
}


let timerId = setInterval(function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, 100);
setTimeout(function() {
    clearInterval(timerId);
}, 100);

function removeUtm(){
  if(window.location.href.indexOf('aftershokz-com?utm_source=') > 0 || window.location.href.indexOf('aftershokz.com/?utm_source=') > 0){
       window.history.pushState({}, document.title, "/" );
   }
}

$('#reviewBt').click(function () {
    $('html, body').animate({
        scrollTop: $('#reviews').offset().top - 200
    }, 500);
    return false;
});


if($('.c-variant-picker__title').text().trim().toUpperCase() == ""){
	$('#reviews').hide();
	$('.c-pdp-gallery__slide').removeClass('c-pdp-gallery__slide--full');
}


$('.afsz-fullimagesM').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	fade: true,
    dots:true,
    asNavFor: '.afsz-thumbs'
}); 
$('.afsz-fullimages').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true, 
  // dots:true,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  asNavFor: '.afsz-thumbs'
});
if($(window).width() < 651){
  $(".afsz-thumbs").slick({ 
	vertical: false,
	infinite: false, 
	asNavFor: ".afsz-fullimagesM",
	slidesToShow: 5,
	slidesToScroll: 1,
	//verticalSwiping: true,
	focusOnSelect: true,
	//centerMode: true,
	rows: 1
}); 
}else{
$(".afsz-thumbs").slick({ 
	vertical: false,
	infinite: false, 
	asNavFor: ".afsz-fullimages",
	slidesToShow: 5,
	slidesToScroll: 1,
	//verticalSwiping: true,
	focusOnSelect: true,
	//centerMode: true,
	rows: 1
}); 
}
 

$('.selectedVariantid').val($('#sVariantid').text());

$(".o-swatch").click(function(){     
  var inp = $(this).find("input");
  var selColor =  $(inp).attr("valuename");
  addSelectedColorImg(selColor);
  // if($('body').hasClass('is-template-product')){
  //   document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  // }
  $('.selectedVariantid').val($('#sVariantid').text());
});

$(".o-toggle.connectivity .o-toggle__switch").click(function(){
  var selColor =  $(this).attr("data-optionimg");
  addSelectedColorImg(selColor);
});


  

  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);

if($(".connectivity.o-toggle .o-toggle__switch.is-active").length > 0){
  addSelectedColorImg("USB-A");
}
function addSelectedColorImg(col){    
 
  if($('.afsz-prod-wrapper').hasClass('fl')){
      let newCol=col;
 if(col.includes('+')) {
  newCol=col.split("+")[0];
 }
	var selectedColor = "." + newCol;
  	selectedColor = selectedColor.trim().replaceAll(" ","-");
	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickFilter',selectedColor);      
    //$('.afsz-prod-wrapper.fl .afsz-thumbs').slick('slickGoTo', -1);
  
	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickFilter',selectedColor);	   
    //$('.afsz-prod-wrapper.fl .afsz-fullimages').slick('slickGoTo', -1);
  
	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
    //$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', -1);
}}

$('#compBt').css('bottom',parseInt($('#compBt').attr('data-bottompos')) + 'em');

function functionAddtoC(id,title,ele){
	var formData = {
	 'items': [{
	  'id':  '32379695202391',
	  'quantity': '1',
      "properties":{ "For": title }
	  }]
	};
	
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: JSON.stringify(formData), 
    	success: function() { location.href = '/cart'; }
  	});   
}


//NIU
function functionProductAddtoC(id){  
	var formData = {
	 'items': [{
	  'id':  id,
	  'quantity': '1',
      "properties":{ "For": " ", "GiftM": " " }
	  }]
	};
	
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: JSON.stringify(formData), 
    	success: function() { location.href = '/cart'; }
  	});   
}
 

$('.giftMInputCheck').change(function(){  
  var tArea = $(this).parents('label').siblings('.addGiftMArea').find('.giftMInput'); 
  if($(this).prop('checked')==true){
  	$(tArea).attr('disabled',false);
  }
  else{
  	$(tArea).attr('disabled',true);
  }
});


$('.addGiftMCheck').click(function(){    
    var tArea = $(this).parents('.addGiftMCheck-box').siblings('.addGiftMArea');       
  	$(tArea).toggle('slow'); 
});

function addGiftMessage(product_ID,lineKey,ele){
  	var msgTXT = "";
    msgTXT = $(ele).siblings('.giftMInput').val();
 	removeProduct(product_ID,lineKey,msgTXT);
  	 //3882354147415	
}

function removeProduct(productID,lineKey,msgTXT){
	var formData = {
	   'line':  lineKey,
       'quantity': 0
	}
     
  	$.ajax({
    	type: 'POST',
    	url: '/cart/change.js',  
    	data: formData, 
    	success: function() {  addProduct(productID,msgTXT) }
  	});  
}

function addProduct1(productID,giftMessage){
	var formData = {
	 'items': [{
	  'id':  productID,
	  'quantity': '1',
      'properties': { 'GiftM': giftMessage } 
     }]
	};
  
	formData = JSON.stringify(formData);
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: formData, 
    	success: function() { location.herf="./cart" }
  	});  
}

function addProduct(productID,giftMessage){
  	let formData = {
		'items': [{
			'id':  productID,
			'quantity': '1',
			'properties': { 'GiftMessage': giftMessage } 
 		}]
	};

	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(formData)
	})
	.then(response => {
      	console.error(response.json);
		return location.href = '/cart';
	})
	.catch((error) => {
		console.error('Error:', error);
	});  
}

function addProductGiftWrap(productID){
	var formData = {
	 	'items': [{
	  		 'id':  32379695202391, //Gift Wrap ID
	 		 'quantity': '1',
      		 'properties':{ 'For(Product ID)': productID } 
        }]
	};
  
	formData = JSON.stringify(formData);
  	$.ajax({
    	type: 'POST',
    	url: '/cart/add.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json',
    	data: formData, 
    	success: function() { }
  	});  
}

function changeProductProp(productID){
	alert(productID);
}

function changeProductProp1(productID){
	var formData = {
	  		 'line':  productID,
      		 'properties': { 'GiftM': 'changed123' } 
        }
    
  	$.ajax({
    	type: 'POST',
    	url: '/cart/change.js',  
    	data: formData, 
    	success: function() { location.href = '/cart'; }
  	});  
  
}


function getItems(){
	$.ajax({
    	type: 'GET',
    	url: '/cart.js', 
      	headers: { 'Content-Type': 'application/json' },
    	dataType: 'json', 
    	success: function(response) { var result = response.items.length; alert(result) }
  	});  
}
  

$(".change-qty-plus").click(function(){
  changeProductQuantity($(this).attr('data-cart-item-index'),parseInt($(this).parents('.add-plus-wrapper').find('.cart__qty-input').val()) - 1);
})
$(".cart__qty-input").change(function(){
  changeProductQuantity($(this).attr('data-cart-item-index'),$(this).val());
})
$(".change-qty-add").click(function(){
  changeProductQuantity($(this).attr('data-cart-item-index'),parseInt($(this).parents('.add-plus-wrapper').find('.cart__qty-input').val()) + 1);
})

function changeProductQuantity(ID,Qty){
  if(Qty<=0){
    Qty = 0;
  }
  var formData = { 'line':  ID, 'quantity': Qty }     
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',  
    data: formData, 
    success: function() { location.href = '/cart'; }
  });  
}

// The product page scrolls to appear modules
/*function initScrollTop(){
  if($('body').hasClass('is-template-product')){
    var backToTop = $('#product__bar-top');
    var headerMenu = $('.c-menu');
    var backToTopBtn = $('#product-top-btn');
    var mbMenuIcon = $('#cssmenu');
    var variantHeight = $('.c-variant-picker__top').height();
    var variantHeightScroll = variantHeight/8;
	var timer = null;
    if(!backToTop) return false;
    window.addEventListener("scroll",function(){  
      clearTimeout(timer);
	  timer = setTimeout(function(){
		if ($(this).scrollTop() > variantHeight) {
			if($(window).width() >769){
			headerMenu.fadeOut(400);
			mbMenuIcon.fadeOut(400);
			}
			backToTop.fadeIn(400);
		  } else {
			backToTop.fadeOut(400);
			if($(window).width() >769){
			headerMenu.fadeIn(400);
			mbMenuIcon.fadeIn(400);
			}
		  } 
	  },100);
    },false);
    backToTopBtn.off('click.scrollTop').on('click.scrollTop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if($(window).width() >769){
        $('html, body').animate({
          scrollTop: 0
        }, 400);
      }else{
        $('html, body').animate({
          scrollTop: variantHeightScroll
        }, 400);
      }

      return false;
    });
  }
}
initScrollTop();*/


// Mobile Product Description
$("#mb-detail-btn").on('click', function() {
  if ($(this).hasClass('open')) {
    $("#mobDesc").children().first().css("display","block").siblings().css("display","none");
    $(this).removeClass('open').find(".more_btn").text("Read More");
  } else {
    $("#mobDesc").children().css("display","block");
    $(this).addClass('open').find(".more_btn").text("Read Less");
  }
});


// Preheader Bar Scroller
$(function(){
  var swiper_mbfp_scroller = new Swiper('.c-preheader-bar__block', {
      direction: 'vertical',
      slidesPerView: 1,
      autoplay: {
        delay: 4000,
      },
      loop: true,
      mousewheel: {
        releaseOnEdges: true,
      }
  });
});



// how it works faq
if ($(window).width() > 800) {
	$('.how-works_wrapper .question_wrapper .item').find('h3').on('click', function () {
		$(this).toggleClass('answer-opened');
		if ($(this).siblings('p').hasClass('open')) {
			$(this).siblings('p').removeClass('open').hide();
		} else {
			$(this).siblings('p').addClass('open').show();
		}
	});
} else {
	$('#how-works_more_btn').on('click', function () {
		$('.how-works_wrapper .question_wrapper .hide-item').slideToggle();
		if ($(this).find('button').hasClass('open')) {
			$(this).find('button').removeClass('open').find('.learn-text').text('Learn More');
		} else {
			$(this).find('button').addClass('open').find('.learn-text').text('Learn Less');
		}
	});
}


// opencomm contact sales button
$("#contact_sales_btn").on('click', function() {
	$("#shopify-section-product-contact--opencomm").css("display","flex");
})
$(".c-product-contact__wrapper .form-close-btn").click(function(){
	$("#shopify-section-product-contact--opencomm").css("display","none");
});


// privacy policy page
$(function(){
  $(".policy-anchor_point li a").bind("click",function(){
    $('html,body').animate({scrollTop: ($($(this).attr('href')).offset().top - 130 )},500);
  });
});

// click cookies accept button popup redirect 
var ctimerecord = setInterval( 
	function(){
	  if($("#cookie_dialog_wrapper").length > 0) {
		$("#cookie_dialog_wrapper #accept_btn").click(function(){
		  $('#cozyCRModal').css("display","block");
		});
		clearInterval(ctimerecord);
	  }
	},500);

  /*var ctimerecord = setInterval( 
	function(){
	  if($("#onetrust-banner-sdk").length > 0) {
		$("#onetrust-banner-sdk #onetrust-accept-btn-handler,.ot-pc-footer .save-preference-btn-handler").click(function(){
		  $('#cozyCRModal').css("display","block");
		});
		clearInterval(ctimerecord);
	  }
	},500); */




// aeropex certified refurbished product spec
$('.c-product-benefits--aeropex-certified-refurbished .c-product-specs__list-wrap').addClass('is-active');





// product page topbar
// $(".bar-add-to-cart").on('click', function() {
//   $('html,body').animate({
//     scrollTop: 0
//   }, 500);
// });




// Add text to the ALT of the picture
$(function(){
  $('img').each(function(){
    if($(this).attr('alt')){
      
    }else{
      // product featured img set
      if($('body').hasClass('is-template-product')){
        let img_text = $.trim($(this).parent().parent().text());
        $(this).attr('alt',img_text);
      }else{
        $(this).attr('alt','Shokz Image');
      }
    }
  });
});


// a add aria-label 
$(function(){
  $('a').each(function(){
    if($(this).attr('aria-label')){

    }else{
      let a_text = $.trim($(this).text());
      if(a_text){
        $(this).attr('aria-label',a_text);
      }else{
        $(this).attr('aria-label','This is a link');
      }
    }
  });
});


// product page h1 add strong
$(function(){
  // .c-variant-picker__title,
  $('.c-product-guarantee__heading,.c-product-feature__heading,.c-product-benefits__title,.c-product-benefit__title,.question_wrapper h4').each(function(){
    $(this).wrapInner('<strong class="b700"></strong>');
  });
  
  $('.class-product-tab .product-tab-item,.section-product-features .features-item .text-wrapper .title,.section-product-what-in-box .what-in-box-wrapper .left-content .title').each(function(){
    // $(this).wrapInner('<strong class="b600"></strong>');
  });
});


// product difference pop
$(".difference-pop").click(function(){
  console.log("test pop");
$(".what-difference-pop").css("display","flex");
setTimeout(function(){
  $(".what-difference-pop").addClass("active");
},10);
});

$(".difference-close-btn").click(function(){
$(".what-difference-pop").removeClass("active");
});




// if($("body").hasClass("is-template-product")){

// $(window).on('scroll', function () {
//   After_scollH = $(window).scrollTop();
//   if(After_scollH>30){
//     $(".c-site-header,#shopify-section-announcement").hide();
//   }else{
//     $(".c-site-header,#shopify-section-announcement").show();
//   }
// })
  
// }






